import React, { useState, useEffect, useCallback } from "react";

import { Title, Tab, Field, Control, Label, Button } from "rbx";

import { Link, Switch, Route, useLocation } from "react-router-dom";

import { useApolloClient } from "react-apollo";

import gql from "graphql-tag";

import moment from "moment";
import { DateInput } from "../../../components/inputs";
import OrderDispatchingGrid from "./OrderDispatchingGrid";

import DriverList from "./DriverList";
import DriverBookingsList from "./DriverBookingsList";

import { getFilterState, saveFilterState } from "../../../utils";
import { useSystemCodes } from "../../../utils/hooks";
import Loading from "../../../components/Loading";

const FILTERS_NAME = "ORDER_DISPATCHING_FILTERS";

const SINGLE_EMPLOYEE_QUERY = gql`
  query Employee($where: EmployeeWhereUniqueInput!) {
    Employee(where: $where) {
      RecId
      FullName
      SeniorityNo
      EmployeeId
    }
  }
`;
const useSelectedDriver = id => {
  const client = useApolloClient();
  const [data, setData] = useState(undefined);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const {
          data: { Employee = {} }
        } = await client.query({
          query: SINGLE_EMPLOYEE_QUERY,
          variables: {
            where: {
              RecId: id
            }
          }
        });
        setData(Employee);
      } catch (err) {
        console.log(err.message);
      } finally {
        setLoading(false);
      }
    };
    if (id) {
      fetchData();
    } else {
      setData(undefined);
    }
  }, [client, id]);
  return { data, loading };
};
const OrderDispatchingPage = () => {
  const SystemCodes = useSystemCodes({
    Category: "BookingCodes",
    CodeName: "BookCatg",
    CodeId: "O"
  });
  const location = useLocation();
  const filterState = getFilterState(FILTERS_NAME, {
    date: moment()
      .add(1, "day")
      .format("YYYY-MM-DD")
  });

  const [date, setDate] = useState(filterState.date);
  const [selected, setSelected] = useState("");
  const { data: selectedDriver } = useSelectedDriver(selected);

  const handleSelect = useCallback(
    id => {
      if (selected === id) {
        setSelected("");
      } else {
        setSelected(id);
      }
    },
    [selected, setSelected]
  );

  const handleChangeFn = fn => e => {
    fn(e.target.value);
  };

  useEffect(() => {
    saveFilterState(FILTERS_NAME, { date });
  }, [date]);

  if (!SystemCodes?.data) {
    return <Loading />;
  }

  return (
    <div id="order-dispatching-container">
      <div className="page-head">
        <div className="page-head-start">
          <Field>
            <Control>
              <Label>Start Date</Label>
              <DateInput
                name="StartDate"
                value={date}
                onChange={handleChangeFn(setDate)}
              />
            </Control>
          </Field>
          <Field>
            <Control>
              <Label>&nbsp; &nbsp;</Label>
              <Button color="primary">Refresh</Button>
            </Control>
          </Field>
          <Field>
            <Control>
              <div style={{ margin: "0 1rem" }}>
                <Title size={3}>
                  {moment(date).format("dddd, MMM D, YYYY")}
                </Title>
              </div>
            </Control>
          </Field>
        </div>
        <div className="page-head-end">
          {selectedDriver && (
            <Title size={3}>
              {String(selectedDriver.SeniorityNo).padStart(4, "0")} -{" "}
              {selectedDriver.FullName} - {selectedDriver.EmployeeId}
            </Title>
          )}
        </div>
      </div>
      <Tab.Group kind="boxed">
        <Tab
          active={location.pathname === "/dispatch/order-dispatching"}
          as={Link}
          tabIndex="-1"
          to="/dispatch/order-dispatching"
        >
          <span>Order Dispatching</span>
        </Tab>
        <Tab
          active={location.pathname.includes("driver-bookings")}
          as={Link}
          tabIndex="-1"
          to="/dispatch/order-dispatching/driver-bookings"
        >
          <span>Driver Bookings</span>
        </Tab>
      </Tab.Group>
      <Switch>
        <Route path="/dispatch/order-dispatching/driver-bookings/:id">
          <DriverBookingsList date={date} />
        </Route>
        <Route path="/dispatch/order-dispatching/driver-bookings">
          <DriverList
            date={date}
            handleSelect={handleSelect}
            selected={selected}
            // REMOVED SO MARK CAN SEE ALL BOOKING STATUSES
            // ExcludeOrderStatus={SystemCodes?.data[0]}
          />
        </Route>
        <Route path="/dispatch/order-dispatching">
          <OrderDispatchingGrid date={date} selectedDriver={selectedDriver} />
        </Route>
      </Switch>
    </div>
  );
};

export default OrderDispatchingPage;
